/**
 * @desc 导出站点SKU供需平衡
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(
  params: API.wms.supplyDemandBalanceDetail.exportByDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/wms/supplyDemandBalanceDetail/export`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
